export default "/_next/static/sounds/vanna_missed_call-f7c4be52eafc9e7184e502da0728aa00.mp3";